export default __webpack_public_path__ + "static/media/eduRed.55e01742.svg";